<div class="login-background-Image">
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
    <p style="color: white"><strong> Loading... </strong></p>
  </ngx-spinner>
  <main class="main d-flex align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-5">

          <div class="text-center mb-4">
            <img src="assets/img/hj-agency-logo.png" alt="BMS Logo" class="login-logo mb-3">
            <h2 class="login-brand-title">Insurance Hub</h2>
          </div>

          <div class="card login-card">
            <div class="card-body">
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <h1>Welcome back</h1>
                <p class="login-subtitle">Sign in to your account</p>

                <div class="input-group mb-3">
                  <span class="input-group-text"><i class="icon-user"></i></span>
                  <input type="text" class="form-control" placeholder="Username" formControlName="username"
                    [ngClass]="{'is-invalid': submitted && f.username.errors}">
                  @if (submitted && f.username.errors) {
                    <div class="invalid-feedback">
                      @if (f.username.errors.required) {
                        <div>Username is required</div>
                      }
                    </div>
                  }
                </div>

                <div class="input-group mb-4">
                  <span class="input-group-text"><i class="icon-lock"></i></span>
                  <input type="password" class="form-control" placeholder="Password" autocomplete="off"
                    formControlName="password"
                    [ngClass]="{'is-invalid': submitted && f.password.errors}">
                  @if (submitted && f.password.errors) {
                    <div class="invalid-feedback">
                      @if (f.password.errors.required) {
                        <div>Password is required</div>
                      }
                    </div>
                  }
                </div>

                <button type="submit" class="btn btn-primary btn-login" [disabled]="isSubmitting">Sign In</button>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>
  </main>
</div>
